import { useTranslation } from 'react-i18next'

import { isEventKeyEnter, preventDefault } from '../../../utils/events'
import Button, { BUTTON_HEIGHT_32 } from '../../Button'
import { Checkbox } from '../../Checkbox'
import { InputField } from '../../Input'
import { Loader } from '../../Loader'
import Text from '../../Text'

import {
  PDF_VIEWER_SEARCH_FIND_NEXT_ICON_PROPS,
  PDF_VIEWER_SEARCH_FIND_PREVIOUS_ICON_PROPS,
  QA_NAME_PDF_VIEWER_SEARCH_CASE_SENSITIVE,
  QA_NAME_PDF_VIEWER_SEARCH_FIND_NEXT_BTN,
  QA_NAME_PDF_VIEWER_SEARCH_FIND_PREVIOUS_BTN,
  QA_NAME_PDF_VIEWER_SEARCH_INPUT,
  QA_NAME_PDF_VIEWER_SEARCH_WHOLE_WORD,
} from './PdfViewerSearchPanel.constants'
import { PdfViewerSearchPanelResult } from './PdfViewerSearchPanelResult'

import * as styles from './PdfViewerSearchPanel.module.css'

function PdfViewerSearchPanel({
  isCaseSensitive,
  isEntireWord,
  isLoading,
  matches,
  query,
  results,
  selectedResultId,
  onChangeQuery,
  onClearQuery,
  onFindNext,
  onFindPrevious,
  onSelectResult,
  onSubmitQuery,
  onToggleCaseSensitive,
  onToggleEntireWord,
}) {
  const { t } = useTranslation()

  const hasMatches = matches?.total > 0

  function handleKeyDown(event) {
    if (isEventKeyEnter(event)) {
      preventDefault(event)

      onSubmitQuery()
    }
  }

  return (
    <div className={styles.PdfViewerSearchPanel}>
      <InputField
        className={styles.inputField}
        height={BUTTON_HEIGHT_32}
        inputProps={{ onKeyDown: handleKeyDown }}
        placeholder={t('Common.SearchPlaceholderKey')}
        qaName={QA_NAME_PDF_VIEWER_SEARCH_INPUT}
        value={query}
        onChange={onChangeQuery}
        onClear={onClearQuery}
      />
      <div className={styles.options}>
        <Checkbox
          checked={isCaseSensitive}
          label={t('PdfViewer.CaseSensitiveKey')}
          labelClassName={styles.checkboxLabel}
          qaName={QA_NAME_PDF_VIEWER_SEARCH_CASE_SENSITIVE}
          onChange={onToggleCaseSensitive}
        />
        <Checkbox
          checked={isEntireWord}
          label={t('PdfViewer.WholeWordKey')}
          labelClassName={styles.checkboxLabel}
          qaName={QA_NAME_PDF_VIEWER_SEARCH_WHOLE_WORD}
          onChange={onToggleEntireWord}
        />
      </div>
      {matches && !isLoading ? (
        <div className={styles.summary}>
          <Text className={styles.summaryText}>
            {t('PdfViewer.ResultsFoundKey', { count: matches.total })}
          </Text>
          <Button.Flat
            isGrey
            beforeIconProps={PDF_VIEWER_SEARCH_FIND_PREVIOUS_ICON_PROPS}
            className={styles.navButton}
            disabled={!hasMatches}
            height={BUTTON_HEIGHT_32}
            qaName={QA_NAME_PDF_VIEWER_SEARCH_FIND_PREVIOUS_BTN}
            tooltip={t('PdfViewer.FindPreviousBtnKey')}
            onClick={onFindPrevious}
          />
          <Button.Flat
            isGrey
            beforeIconProps={PDF_VIEWER_SEARCH_FIND_NEXT_ICON_PROPS}
            className={styles.navButton}
            disabled={!hasMatches}
            height={BUTTON_HEIGHT_32}
            qaName={QA_NAME_PDF_VIEWER_SEARCH_FIND_NEXT_BTN}
            tooltip={t('PdfViewer.FindNextBtnKey')}
            onClick={onFindNext}
          />
        </div>
      ) : null}
      <div className={styles.results}>
        {isLoading ? (
          <Loader className={styles.loader} />
        ) : (
          results.map(result => (
            <PdfViewerSearchPanelResult
              isSelected={result.id === selectedResultId}
              key={result.id}
              result={result}
              onSelect={onSelectResult}
            />
          ))
        )}
      </div>
    </div>
  )
}

export default PdfViewerSearchPanel
